// extracted by mini-css-extract-plugin
export default {"banner":"styles_banner__OMKKn","banner__content":"styles_banner__content__42ZLW"};